(function () {
  'use strict';
  var GRID = '[data-serrano-shop-all-grid]';

  function installStyles() {
    if (document.getElementById('serrano-shop-all-polish')) return;
    var style = document.createElement('style');
    style.id = 'serrano-shop-all-polish';
    style.textContent = GRID + ' h3{font-weight:500!important;letter-spacing:0!important;line-height:1.25!important}' +
      GRID + ' .serrano-variant-tile__price{font-weight:400!important}' +
      GRID + ' .product-tile__quick-buy,' + GRID + ' .serrano-variant-tile__quick-buy{width:100%!important;margin-top:12px!important}' +
      GRID + ' .product-quick-buy__container{width:100%!important;max-width:none!important;margin-left:0!important;margin-right:0!important}' +
      GRID + ' .product-tile__quick-buy .push-btn,' + GRID + ' .serrano-variant-tile__quick-buy .push-btn{display:block!important;width:100%!important}' +
      GRID + ' .product-tile__quick-buy .push-btn__surface,' + GRID + ' .serrano-variant-tile__quick-buy .push-btn__surface{display:flex!important;width:100%!important;min-height:48px!important;align-items:center!important;justify-content:center!important;padding:10px 16px!important;font-size:14px!important}' +
      GRID + ' .serrano-variant-quick-add__status{min-height:1.2em;margin-top:5px;font-size:11px;text-align:center}' +
      '@media(max-width:749px){' + GRID + ' h3{font-size:12.5px!important;line-height:1.2!important}' + GRID + ' .product-tile.mt-5,' + GRID + ' .serrano-variant-tile__details{margin-top:10px!important}' + GRID + ' .product-tile__quick-buy,' + GRID + ' .serrano-variant-tile__quick-buy{margin-top:9px!important}' + GRID + ' .product-tile__quick-buy .push-btn__surface,' + GRID + ' .serrano-variant-tile__quick-buy .push-btn__surface{min-height:44px!important;font-size:12px!important;padding:8px 10px!important}}' +
      '@media(min-width:750px){' + GRID + ' h3{font-size:14px!important}}';
    document.head.appendChild(style);
  }

  function installVirtualQuickAdd() {
    if (window.__serranoVirtualQuickAddInstalled) return;
    window.__serranoVirtualQuickAddInstalled = true;
    document.addEventListener('submit', function (event) {
      var form = event.target.closest && event.target.closest('form.serrano-variant-quick-add');
      if (!form) return;
      event.preventDefault();
      var button = form.querySelector('button[type="submit"]');
      var label = form.querySelector('[data-serrano-quick-add-label]');
      var status = form.querySelector('[data-serrano-quick-add-status]');
      if (!button || button.disabled) return;
      var originalLabel = label ? label.textContent : 'Sepete ekle';
      button.disabled = true;
      if (status) status.textContent = '';
      fetch('/cart/add.js', { method:'POST', credentials:'same-origin', headers:{Accept:'application/json'}, body:new FormData(form) })
        .then(function (response) { if (response.ok) return response.json(); return response.json().then(function (data) { throw data; }); })
        .then(function () { if (label) label.textContent = 'Eklendi ✓'; if (status) status.textContent = 'Sepete eklendi.'; document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles:true })); })
        .catch(function (error) { if (status) status.textContent = (error && (error.description || error.message)) || 'Sepete eklenemedi.'; })
        .finally(function () { window.setTimeout(function () { button.disabled = false; if (label) label.textContent = originalLabel; }, 1200); });
    }, true);
  }

  function init() {
    if (!document.querySelector(GRID)) return;
    installStyles();
    installVirtualQuickAdd();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once:true });
  else init();
})();
